export interface BackofficeUser {
  firstName: string;
  lastName: string;
  avatar: string;
  email: string;
  permissions: string[],
}

export enum UserRoleName {
  Admin = 'ADMIN',
  Creator = 'CREATOR',
  Collaborator = 'COLLABORATOR',
}

export interface UserMetadata {
  role: string;
  userRoleName?: UserRoleName;
}

export interface User {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  profilePictureUrl: string;
  accountId: string;
  userRoleName: UserRoleName;
  accountIds: string[];
  activatedForAccount: boolean;
  superUser: boolean;
  verified: boolean;
  provider: string;
  metadata?: UserMetadata;
  emailVerified: boolean;
  dailyStreak?: number;
  requestedCustomOutreachCampaign?: boolean;
  lastLogin: Date;
}
